import React from 'react';
import Modal from 'react-modal';
import CreateEditSite from "../components/site/CreateEditSite";

const CreateEditSiteModal = (props) => {
    const {
        customerId  = null,
        siteId      = null,
        show        = false,
        parentId    = "",
        disabled    = false,
        onCancel    = () => {},
        onComplete  = (site) => {},
        onDelete    = (site) => {},
        id          = "create-edit-site-modal",
    } = props;

    const handleCancel = () => {
        onCancel();
    }

    const handleComplete = (site) => {
        onComplete(site);
    }

    const handleDelete = (site) => {
        onDelete(site);
    }

    return (
        <Modal
            ariaHideApp={false}
            isOpen={show}
            parentSelector={() => document.getElementById(parentId)}
            onRequestClose={() => handleCancel()}
            contentLabel={!!siteId ? "Edit Site" : "Create Site"}
            className={'ReactModal__Content react-modal-outer modal-dialog admin-modal wide-modal allow-overflow'}
            style={{
                overlay: {
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    overflow: 'hidden',
                    outline: 'none',
                },
                content: {
                    width: "100%",
                    height: "100%",
                    padding: 0,
                    border: 0,
                    outline: 'none',
                },
            }}
        >
            <div className="p-4 modal-content" id={id}>
                <div className="modal-header border-0 m-0 p-0 pb-4">
                    <h4 className="modal-title text-eh-navy">{!!siteId ? "Edit Site" : "Add Site"}</h4>
                    <button
                        type="button" className="close"
                        data-dismiss="modal" aria-label="Close"
                        onClick={() => handleCancel()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body m-0 mb-3 p-0">
                    <CreateEditSite
                        siteId={siteId}
                        customerId={customerId}
                        onCancel={() => handleCancel()}
                        onComplete={(site) => handleComplete(site)}
                        onDelete={(site) => handleDelete(site)}
                        parentId={parentId}
                    />
                </div>
            </div>
        </Modal>
    );
}

export default CreateEditSiteModal;
